export const dadosTipoLancamentoStyles = {}
